// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/bai_login_background_blue.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/bai_login_background_gray.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/BAI_Learning_Manager_Logo_White.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Background */
.loginBg {
  height: 100%;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  left: 0;
  top: auto;
  z-index: 1;
}

div.loginBgGrayOverride {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* The visit BAI link in the top right corner */
.visit-bai {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: white;
  font-weight: bold;
  padding-top: 3vh;
}

.visit-bai a {
  color: white;
  margin-right: 17vmin;
}

/* logo */
.login h1#logo {
  margin-top: 1.5vh;
  margin-bottom: 1vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center;
  text-indent: 0;
  min-width: 17vw; /* @TODO: fix this up */
  width: 100%;
  height: 11vmin;
  background-size: contain;
}

/* Login form layout */
#loginPageContainer {
  width: 100vw;
  z-index: 4;
  height: 100%;
  position: fixed;
  left: 0;
  top: auto;
  overflow: hidden;
}

.loginFormContainer {
  margin: 0 auto;
  width: 100%;
}

.loginFormContainer {
  padding-bottom: 1rem;
  width: 33vw;
}

.loginFormContainer form {
  background-color: white;
  padding-top: 5vh;
  padding-bottom: 6vh;
}

form .poweredByBai {
  margin-top: -2rem;
  float: right;
  align-items: baseline;
  display: none;
  position: absolute;
  bottom: 15px;
  right: 0px;
}

form .poweredByBai span {
  margin-right: 1rem;
}

form .poweredByBai img {
  margin-right: 1.5rem;
  width: 30px;
  height: 30px;
}

/* Login form title */
.loginFormContainer h3 {
  font-family: 'Rockwell', Times, 'Times New Roman', serif;
  font-size: 2.3vw;
  text-align: center;
  color: white;
  background-color: none;
  width: 33vw;
  padding-bottom: 2rem;
  margin-bottom: 0;
  /*margin-top: 5.5vh;*/
}

/* Hide all forms initially 
 * These will be activated by angular
 * */

.login .enterpin,
.login .forgotpassword,
.login .loading,
.login .resetpassword {
  display: none;
}

/* Style the input elements */
.loginFormContainer form div.form-group input {
  background-color: white;
  color: #747474;
  margin-bottom: 7px;
  padding: 7px;
  width: 100%;
  border-radius: 0px;
  margin-bottom: 1.5rem;
  height: 7vh;
  text-shadow: 0 0 0.01px rgba(0, 0, 0, 0.5);
  font-size: 20px;
  padding-left: 1em;
}

.loginFormContainer form p {
  margin-left: 2.5vw;
  margin-right: 2.5vw;
}

.loginFormContainer .form-group {
  margin-left: 2.4vw;
  margin-right: 2.4vw;
  margin-bottom: 2.5vh;
}

#loginPageContainer button.btn-default.portalBackground {
  font-size: 16px;
  width: 41%;
  margin-left: 2.3vw;
  margin-top: 1vh;
  border-radius: 12px;
  text-transform: none;
  text-shadow: none;
  height: 6vh;
}

a.portalLoginLink {
  color: rgb(22, 170, 230);
  margin-top: 2.5vh;
  display: block;
  margin-left: 3vw;
  font-size: 16px;
}

/* Error group styling */
.loginFormContainer.enterpin .error-group,
.loginFormContainer.forgotpassword .error-group,
.loginFormContainer.resetpassword .error-group,
.loginFormContainer.signin .error-group {
  overflow: hidden;
}

.loginFormContainer .error-group {
  margin-bottom: 0;
}

.loginFormContainer .error {
  background-color: #f00;
  display: none;
  float: right;
  padding: 3px 15px;
}

/* Help and copyright at bottom of page */
.loginHelpText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
}

.loginHelpText p {
  width: 33vw;
  align-self: center;
  text-align: left;
  font-size: 1.3rem;
  font-weight: bold;
  padding-top: 0.9rem;
  margin-bottom: 0;
}

.loginCopyright {
  display: flex;
  position: absolute;
  bottom: 0;
  justify-content: center;
  width: 100%;
}

.loginCopyright p {
  width: 33vw;
  text-align: center;
  font-weight: normal;
  font-size: 1rem;
  color: white;
  margin-bottom: 2rem;
}

.loginCopyright p a {
  color: #fff;
  font-size: 1rem;
}

.MuiOutlinedInput-root {
  font-family: Calibri;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/login/login.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,YAAY;EACZ,WAAW;EACX,yDAA0E;EAC1E,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yDAA0E;AAC5E;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yDAAgF;EAChF,2BAA2B;EAC3B,cAAc;EACd,eAAe,EAAE,uBAAuB;EACxC,WAAW;EACX,cAAc;EACd,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,eAAe;EACf,OAAO;EACP,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,wDAAwD;EACxD,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;IAEI;;AAEJ;;;;EAIE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["/* Background */\n.loginBg {\n  height: 100%;\n  width: 100%;\n  background-image: url('../../assets/images/bai_login_background_blue.jpg');\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: fixed;\n  left: 0;\n  top: auto;\n  z-index: 1;\n}\n\ndiv.loginBgGrayOverride {\n  background-image: url('../../assets/images/bai_login_background_gray.jpg');\n}\n\n/* The visit BAI link in the top right corner */\n.visit-bai {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  color: white;\n  font-weight: bold;\n  padding-top: 3vh;\n}\n\n.visit-bai a {\n  color: white;\n  margin-right: 17vmin;\n}\n\n/* logo */\n.login h1#logo {\n  margin-top: 1.5vh;\n  margin-bottom: 1vh;\n  background-image: url('../../assets/images/BAI_Learning_Manager_Logo_White.svg');\n  background-position: center;\n  text-indent: 0;\n  min-width: 17vw; /* @TODO: fix this up */\n  width: 100%;\n  height: 11vmin;\n  background-size: contain;\n}\n\n/* Login form layout */\n#loginPageContainer {\n  width: 100vw;\n  z-index: 4;\n  height: 100%;\n  position: fixed;\n  left: 0;\n  top: auto;\n  overflow: hidden;\n}\n\n.loginFormContainer {\n  margin: 0 auto;\n  width: 100%;\n}\n\n.loginFormContainer {\n  padding-bottom: 1rem;\n  width: 33vw;\n}\n\n.loginFormContainer form {\n  background-color: white;\n  padding-top: 5vh;\n  padding-bottom: 6vh;\n}\n\nform .poweredByBai {\n  margin-top: -2rem;\n  float: right;\n  align-items: baseline;\n  display: none;\n  position: absolute;\n  bottom: 15px;\n  right: 0px;\n}\n\nform .poweredByBai span {\n  margin-right: 1rem;\n}\n\nform .poweredByBai img {\n  margin-right: 1.5rem;\n  width: 30px;\n  height: 30px;\n}\n\n/* Login form title */\n.loginFormContainer h3 {\n  font-family: 'Rockwell', Times, 'Times New Roman', serif;\n  font-size: 2.3vw;\n  text-align: center;\n  color: white;\n  background-color: none;\n  width: 33vw;\n  padding-bottom: 2rem;\n  margin-bottom: 0;\n  /*margin-top: 5.5vh;*/\n}\n\n/* Hide all forms initially \n * These will be activated by angular\n * */\n\n.login .enterpin,\n.login .forgotpassword,\n.login .loading,\n.login .resetpassword {\n  display: none;\n}\n\n/* Style the input elements */\n.loginFormContainer form div.form-group input {\n  background-color: white;\n  color: #747474;\n  margin-bottom: 7px;\n  padding: 7px;\n  width: 100%;\n  border-radius: 0px;\n  margin-bottom: 1.5rem;\n  height: 7vh;\n  text-shadow: 0 0 0.01px rgba(0, 0, 0, 0.5);\n  font-size: 20px;\n  padding-left: 1em;\n}\n\n.loginFormContainer form p {\n  margin-left: 2.5vw;\n  margin-right: 2.5vw;\n}\n\n.loginFormContainer .form-group {\n  margin-left: 2.4vw;\n  margin-right: 2.4vw;\n  margin-bottom: 2.5vh;\n}\n\n#loginPageContainer button.btn-default.portalBackground {\n  font-size: 16px;\n  width: 41%;\n  margin-left: 2.3vw;\n  margin-top: 1vh;\n  border-radius: 12px;\n  text-transform: none;\n  text-shadow: none;\n  height: 6vh;\n}\n\na.portalLoginLink {\n  color: rgb(22, 170, 230);\n  margin-top: 2.5vh;\n  display: block;\n  margin-left: 3vw;\n  font-size: 16px;\n}\n\n/* Error group styling */\n.loginFormContainer.enterpin .error-group,\n.loginFormContainer.forgotpassword .error-group,\n.loginFormContainer.resetpassword .error-group,\n.loginFormContainer.signin .error-group {\n  overflow: hidden;\n}\n\n.loginFormContainer .error-group {\n  margin-bottom: 0;\n}\n\n.loginFormContainer .error {\n  background-color: #f00;\n  display: none;\n  float: right;\n  padding: 3px 15px;\n}\n\n/* Help and copyright at bottom of page */\n.loginHelpText {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: white;\n}\n\n.loginHelpText p {\n  width: 33vw;\n  align-self: center;\n  text-align: left;\n  font-size: 1.3rem;\n  font-weight: bold;\n  padding-top: 0.9rem;\n  margin-bottom: 0;\n}\n\n.loginCopyright {\n  display: flex;\n  position: absolute;\n  bottom: 0;\n  justify-content: center;\n  width: 100%;\n}\n\n.loginCopyright p {\n  width: 33vw;\n  text-align: center;\n  font-weight: normal;\n  font-size: 1rem;\n  color: white;\n  margin-bottom: 2rem;\n}\n\n.loginCopyright p a {\n  color: #fff;\n  font-size: 1rem;\n}\n\n.MuiOutlinedInput-root {\n  font-family: Calibri;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
